export default __webpack_public_path__ + "static/media/27.08942a99.png";